import { CancelToken } from 'axios';
import { ContentPageParams, getGroupContents } from '@front-app/services/GroupsApi/GroupsContentApi';
import { Content } from '@front-app/services/GroupsApi/DiscussionModel';
import { ThrottledSearch, useThrottledApi } from './useThrottledApi';

/**
 * This is simplified version of the Content API, intended to be used only for simple searching by name
 * For complex use cases, including proper pagination, consider the groupContentStore
 */
const cancellableSearchFiles = (
	token: CancelToken,
	groupId: string,
	pageNum: number,
	params: ContentPageParams,
) => getGroupContents(groupId, pageNum, params, token).then(({ contents }) => contents);

type FileSearchArgs = [groupId: string, pageNum: number, params: ContentPageParams];

export const useThrottledFilesSearchSource = (): ThrottledSearch<FileSearchArgs, Content[]> => useThrottledApi(
	cancellableSearchFiles,
	{
		shouldShortCircuit: (groupId: string, pageNum: number, params: ContentPageParams) => !params.search,
		emptyResultFactory: () => [],
		catchAndReturnEmptyOnCancellation: true,
	},
);
